<script>
import {Storage} from "@ionic/storage";

export default {
  name: 'StorageService',
  data() {
    return {
      localStorage: new Storage()
    }
  },
  mounted() {
    this.localStorage.create();
  },
  methods: {
    async setLocalStorage(index, value) {
      return await this.localStorage.set(index, value);
    },
    async getLocalStorage(index) {
      return await this.localStorage.get(index);
    },
    async removeLocalStorage(index) {
      return await this.localStorage.remove(index);
    },
    async clearLocalStorage() {
      return await this.localStorage.clear();
    }
  }
};
</script>